import { __awaiter } from '../external_node_modules/tslib/tslib.es6.js';
import { getProductVariablePrice } from '../api/storefront.js';
import { VariablePriceEntity } from '../core/entity/varuablePrice.entity.js';
import settings from '../settings.js';

function getProductPrice(productCode, quantity, platform, customStorefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        const variablePrice = yield getProductVariablePrice(productCode, quantity, platform, customStorefrontName, settings.language);
        if (!variablePrice) {
            return null;
        }
        const entity = new VariablePriceEntity();
        entity.clientPaymentMethodIds = variablePrice.clientPaymentMethodIds;
        entity.discounts = variablePrice.discounts;
        entity.price = variablePrice.price;
        entity.rewards = variablePrice.rewards;
        entity.productCode = productCode;
        return entity;
    });
}

export { getProductPrice };
//# sourceMappingURL=product_price.js.map
